import React from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Grid } from '@mui/material'
import { styled } from '@mui/styles'
import { muiTheme } from '@pbt/pbt-ui-components'

import Avatar from '~/components/common/Avatar'
import { SendGearIcon as SystemMessageIcon } from '~/components/elements/Icons/generated'

import SystemMessageLabel from '../../common/SystemMessageLabel'

const StyledWrapperGrid = styled(Grid)(({ theme }) => ({
  border: theme.constants.tableBorder,
  borderRadius: 2,
  color: theme.colors.grayGray3,
}))

const StyledUserText = styled(Grid)(({ theme }) => ({
  borderRight: theme.constants.tableBorder,
  padding: theme.spacing(0.5, 1),
  paddingRight: theme.spacing(4),
  height: '100%',
  opacity: 0.5,
}))

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  height: 32,
  width: 32,
  backgroundColor: theme.colors.grayGray3,
  color: theme.colors.grayGray1,
}))

const StyledExpandMoreIcon = styled(ExpandMoreIcon)(({ theme }) => ({
  color: theme.colors.grayGray2,
  margin: theme.spacing(0, 0.5),
  opacity: 0.5,
}))

const SystemUserSelect = () => (
  <StyledWrapperGrid container alignItems="center" direction="row">
    <StyledUserText item direction="row">
      <SystemMessageLabel
        isSelectOption
        color={muiTheme.colors.grayGray1}
        fontSize="ParagraphLg"
        icon={
          <StyledAvatar>
            <SystemMessageIcon />
          </StyledAvatar>
        }
      />
    </StyledUserText>
    <StyledExpandMoreIcon />
  </StyledWrapperGrid>
)

export default SystemUserSelect
